import { datadogRum } from '@datadog/browser-rum';
import { toast } from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

import ConfirmationModal from '@/components/popups/ConfirmationModal';
import ToastMessageBlock from '@/components/Toasts/SuccessToast';

import { setOperatorCourseSetting } from '@/_generated/api-clients/content';
import { OperatorDto } from '@/_generated/api-clients/xp';

interface EnablePlanProps {
  courseId: string;
  courseName: string;
  operators: OperatorDto[];
  refetchPlans: () => void;
  setShowEnablePlanPopUp: (show: boolean) => void;
  showEnablePlanPopUp: boolean;
}

const EnablePlan: React.FC<EnablePlanProps> = ({
  courseId,
  courseName,
  operators,
  refetchPlans,
  setShowEnablePlanPopUp,
  showEnablePlanPopUp,
}) => {
  const { t } = useTranslation();

  const onContinue = () => {
    setOperatorCourseSetting({
      query: { operatorId: operators.at(0)?.id ?? '' },
      path: { courseId, enable: 'enable' },
    })
      .then(() => {
        toast.custom(toastObj => (
          <ToastMessageBlock id={toastObj.id}>
            {t('TrainingPlans.toastMessage.enabled', { courseName })}
          </ToastMessageBlock>
        ));
        refetchPlans();
      })
      .catch((err: unknown) => {
        datadogRum.addError(
          err instanceof Error ? err : new Error(String(err)),
        );
      });
    setShowEnablePlanPopUp(false);
  };
  return (
    <ConfirmationModal
      bodyText={t('Settings.complianceEnable', {
        name: courseName,
      })}
      headerText={t('Generic.enablePlan')}
      isOpen={showEnablePlanPopUp}
      onClose={() => setShowEnablePlanPopUp(false)}
      primaryButtonHandler={onContinue}
      primaryButtonText={t('Button.continue')}
      secondaryButtonHandler={() => setShowEnablePlanPopUp(false)}
      secondaryButtonText={t('Button.cancel')}
    />
  );
};

export default EnablePlan;
